import React from "react";
import { homeImage } from "../../assets";
import StartExamButton from "./common/StartExamButton";
import moment from "moment";

const Main = () => {
  const currentDate = new Date();
  const date = moment(currentDate).format("MMM Do YY");

  return (
    <>
      <section className="flex flex-col gap-[4.5rem]">
        {/*Top section  */}
        <div className="flex flex-col">
          <h2 className="text-[28px] font-semibold text-textPrimary leading-[40px]">
            Exam Info
          </h2>
          <span className="pb-5 text-textSecondary text-sm">
            General Exam information:
          </span>
          <div className="flex md:flex-row flex-col-reverse sm:gap-[45px] gap-6 sm:items-center">
            <div className="basis-5/12">
              <img
                src={homeImage}
                className="w-full h-full object-cover rounded-[10px]"
                alt=""
              />
            </div>
            <div className="basis 7/12 grid grid-cols-2 md:grid-rows-5 grid-rows-4 gap-4 md:w-[50%]">
              <span className="sm:text-[18px] text-textPrimary font-semibold">
                Date:
              </span>
              <span className="sm:text-[18px] text-textSecondary">{date}</span>
              <span className="sm:text-[18px] text-textPrimary font-semibold">
                Time Limit:
              </span>
              <span className="sm:text-[18px] text-textSecondary">
                10 Minutes
              </span>
              <span className="sm:text-[18px] text-textPrimary font-semibold">
                Attempts:
              </span>
              <span className="sm:text-[18px] text-textSecondary">
                Unlimited
              </span>
              <span className="sm:text-[18px] text-textPrimary font-semibold">
                Points:
              </span>
              <span className="sm:text-[18px] text-textSecondary">
                Topic Based
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div>
          <div className="mb-5">
            <h2 className="text-[28px] font-semibold text-textPrimary leading-[40px]">
              Instructions
            </h2>
            <span className="text-textSecondary text-sm">
              Please read carefully before starting the test:
            </span>
          </div>
          <ul className="list-disc flex flex-col gap-2 pt-3 pl-[40px]">
            <li>
              This exam consists of many multiple-choice questions. To be
              successful with the exams, it's important to conversant with the
              topics.
            </li>
            <li>
              Timing - You need to complete each of your attempts in one
              sitting, as you are allotted 10 minutes to each attempt.
            </li>
            <li>
              Answers - You may review your answer-choices and compare them to
              the correct answers after your final attempt.
            </li>
            <li>
              To start, click the "Start" button. When finished, click the
              "Submit " button.
            </li>
          </ul>
        </div>
        <div className="md:self-end md:pr-4 self-center">
          <StartExamButton
            data="Start"
            styles="border border-textSecondary bg-transparent text-textPrimary hover:bg-secondary hover:text-primary py-1 hover:ease-in duration-100"
          />
        </div>
      </section>
    </>
  );
};

export default Main;
